import * as mathUtil from '@/common/js/mathutil.js'

import Decimal from '@/math/types/decimal.js'
import Equation from '@/math/types/equation.js'

export default {
  title: 'Subtract decimals with hundredths (with grid)',
  operation: 'long-add-decimal',
  instruction: 'Find the difference.',
  config: { nProblems: 10, maxWholePlaces: 1, maxDecPlaces: 2 },
  equation: function () {
    var lhs1whole = mathUtil.randomIntUniform(0, 9)
    var lhs2whole = mathUtil.randomIntUniform(0, 9)

    var lhs1dec = mathUtil.randomIntPowerLaw(1, 99)
    while (lhs1dec % 10 === 0) {
      lhs1dec = mathUtil.randomIntPowerLaw(1, 99)
    }

    var lhs2dec = mathUtil.randomIntPowerLaw(1, 99)
    while (lhs2dec % 10 === 0) {
      lhs2dec = mathUtil.randomIntPowerLaw(1, 99)
    }

    var lhs1 = new Decimal(lhs1whole + '.' + lhs1dec.toString().padStart(2, '0'))
    var lhs2 = new Decimal(lhs2whole + '.' + lhs2dec.toString().padStart(2, '0'))

    var swap = lhs1.lessThan(lhs2)
    if (swap) return new Equation('−', lhs2, lhs1, lhs2.sub(lhs1))
    else return new Equation('−', lhs1, lhs2, lhs1.sub(lhs2))
  }
}



// WEBPACK FOOTER //
// ./src/math/drills/dec/decpyhj.js